import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader, CourseCard, DataNotFound } from "../../components";
import { useDispatch, useSelector } from "react-redux";
import { reqToGetUserCourseList } from "../../store/slice/coursesSlice";
import { dataMessage } from "../../helpers/messages";
import { routes } from "../../helpers/constants";

const Courses = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loader, userCourseList } = useSelector(
    (state) => state.coursesReducer
  );

  useEffect(() => {
    handleGetInitialData();
  }, []);

  const handleGetInitialData = () => {
    if (Array.isArray(userCourseList) && userCourseList?.length > 0) {
      return;
    }
    dispatch(reqToGetUserCourseList({}));
  };

  const handleSelectCourse = (course) => {
    navigate(routes.courseModule, { state: { sCourse: course,title: course?.name} });
  };

  return (
    <>
      {loader && <Loader />}
      <div className="lms-body">
        <div className="d-flex align-items-center justify-content-between mb-4">
          <div className="lms-profile-wrapper mb-0">
            <span className="lms-profile-name">COURSE</span>
          </div>
          <div className="text-end fs-18">
            <p className="mb-0 fw-semibold">August 2025</p>
            <p className="mb-0">As of Tuesday, August 19</p>
          </div>
        </div>
        <div className="lms-content-wrapper lms-content-text">
          <div className="lms-course text-end fs-18 fw-600 mb-3 pb-2">
            Total Courses: {userCourseList?.length || 0}
          </div>

          <div className="overflow-y lms-ceontent-course">
            <div className="row g-4">
              {Array.isArray(userCourseList) && userCourseList?.length > 0 ? (
                userCourseList.map((course, index) => (
                  <div
                    className="col-12 col-md-6 col-xl-4 lms-cousrse-cards"
                    key={index}
                  >
                    <CourseCard
                      course={course}
                      type="course"
                      count={course?.module_count || 0}
                      onClick={handleSelectCourse}
                    />
                  </div>
                ))
              ) : (
                <DataNotFound message={dataMessage.noCourses} />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Courses;
